import { render, staticRenderFns } from "./WaitingListConfigurationWizardButtons.vue?vue&type=template&id=3439d328&"
import script from "./WaitingListConfigurationWizardButtons.vue?vue&type=script&lang=js&"
export * from "./WaitingListConfigurationWizardButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports